import React from "react";
import {SearchForm} from "./searchForm"
import OrganTree from "./organTree"
import OrganForm from "./organForm"

export const Organization = () => {
    return (
        <>
            <SearchForm/>
            <div className="flex" style={{height: "calc(100vh - 180px)"}}>
                <OrganTree/>
                <OrganForm/>
            </div>
        </>
    )
}